import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IApiTokenDto } from 'gen/ApiClient';
import React from 'react';
import { ApiTokensSelectableColumn } from './ApiTokensSelectableColumn';

interface IViewContext extends ITableViewContext<ApiTokensSelectableColumn, IApiTokenDto> {}

export const ApiTokensListViewContext = React.createContext<IViewContext>(undefined as any);
